/** ----------------------------------------------------------------------------------------------
 * Fix potentially invalid canonical that might not contain the id of the article
 * The server part of our br24 web client takes care that articles are always redirected to their
 * proper canonical url that contains the id of the article.
 *
 * For some older articles, the rowId is missing in the shareUrl but the server still executes the
 * redirect. Therefore, we add the rowId to the canonical url if it is missing.
 *
 * This ensures that our sitemaps are valid and don't link to an articles that will trigger
 * a redirect
 * _______________________________________________________________________________________________ */
export function ensureArticleUrlIncludesRowId(url: string, rowId: string) {
	const urlObject = new URL(url);
	const pathname = urlObject.pathname;
	const lastPathnameCrumb = pathname.split('/').pop();

	/* if `,${rowId}` is not part of the pathname */
	if (lastPathnameCrumb?.split(',').length !== 2) {
		/* append the rowId to the canonical url */
		urlObject.pathname = pathname + ',' + rowId;
	}

	return urlObject.href;
}
